import { render, staticRenderFns } from "./AIAnalysisModal.vue?vue&type=template&id=281f984f&scoped=true"
import script from "./AIAnalysisModal.vue?vue&type=script&lang=js"
export * from "./AIAnalysisModal.vue?vue&type=script&lang=js"
import style0 from "./AIAnalysisModal.vue?vue&type=style&index=0&id=281f984f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281f984f",
  null
  
)

export default component.exports